import React from 'react';

import { NoPermissionToAddIssueTypeModal } from '@qality/common-components/src/NoPermissionToAddIssueTypeModal';
import { PurpleButtonStyled } from '@qality/common-components/src/atoms/PurpleButton';

export const AddIssueTypeButtonView = ({
  showNoPermissionModal,
  handleCloseModal,
  handleClick,
}: any) => {
  return (
    <>
      <PurpleButtonStyled onClick={() => handleClick()}>
        Add issue type
      </PurpleButtonStyled>
      <NoPermissionToAddIssueTypeModal
        onClose={handleCloseModal}
        showModal={showNoPermissionModal}
      />
    </>
  );
};
